// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3Rnh9","footer":"ModalCreateQualiphyProcedure_footer__qYOdd","additionData":"ModalCreateQualiphyProcedure_additionData__1PQxT"};